import Link, { LinkProps } from 'next/link';
import React, { useMemo } from 'react';
import { pickChild } from '../utils/collections';
import withDefaults from '../utils/with-defaults';
import StepsSeparator from './StepsSeparator';

interface Props {
    href?: string
    nextLink?: boolean
    onClick?: (event: React.MouseEvent) => void
    className?: string
    active: boolean
    success: boolean
}

const defaultProps = {
    nextLink: false,
    className: '',
    active: false,
    success: false,
}

type NativeAttrs = Omit<React.AnchorHTMLAttributes<any>, keyof Props>
type NativeLinkAttrs = Omit<NativeAttrs, keyof LinkProps>
export type StepsProps = Props & typeof defaultProps & NativeLinkAttrs


const StepsItem = React.forwardRef<
    HTMLAnchorElement,
    React.PropsWithChildren<StepsProps>
>(
    (
        { href, nextLink, onClick, children, className, active, success, ...props },
        ref: React.Ref<HTMLAnchorElement>,
    ) => {
        const isLink = useMemo(() => href !== undefined || nextLink, [href, nextLink])
        const [withoutSepChildren] = pickChild(children, StepsSeparator)
        const clickHandler = (event: React.MouseEvent) => {
            onClick && onClick(event)
        }

        const itemClassName = ` ${className} pb-1 font-bold whitespace-nowrap ${active ? 'border-b-3 border-primary-500 text-primary-500' : success ? 'text-green-600' : 'text-gray-650'}`;

        if (!isLink) {
            return (
                <span onClick={clickHandler} className={itemClassName}>
                    {withoutSepChildren}
                </span>
            )
        }

        return (
            <Link
                href={href}
                {...props}>
                <a className={itemClassName}>
                    {withoutSepChildren}
                </a>
            </Link>
        )
    },
)

const MemoStepsItem = React.memo(StepsItem)

export default withDefaults(MemoStepsItem, defaultProps)
